/**
 * @param data to clone
 * @returns deeply cloned object
 * According our measurements this a fastest approach to clone huge objects like parts of video data.
 */
export function cloneDeep<T>(data: T): T {
    return JSON.parse(JSON.stringify(data));
}

export function cloneDeepIfEqualTo(data: any, value: any): any {
    return data === value ? cloneDeep(data) : data;
}

